import http from '@/utils/http';

// 获取游戏列表
export function fetchGamesByKeyword(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/compareSearch',
    method: 'post',
    data: params,
    rawData: true,
  });
}

export async function fetchSimilarGames(params: {
  entity_type: string;
  game_ids: {
    entity_type: string;
    game_id: string;
  }[];
}): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/similarGame',
    method: 'post',
    data: params,
  }) as Promise<any>;
}

// 获Compare页
export const getCompareMetric = (params: any): Promise<any> =>
  http({
    url: '/api/v1/intelligence_pc/compare/compareMobileMetric',
    method: 'post',
    data: params,
    rawData: true,
  });

// 获取CompareGame可视化数据
export const fetchCompareGameTrends = (params: any): Promise<any> =>
  http({
    url: '/api/v1/intelligence_pc/compare/compareMobileTrends',
    method: 'post',
    data: params,
    rawData: true,
  });

// 获取CompareStoreRank单国家
export function getCompareStroeRank(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/compareMobileStoreRankCNT',
    method: 'post',
    data: params,
    rawData: true,
  });
}

// 获取CompareStoreRank多国家
export function getCompareStroeRankMul(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/compareMobileStoreRankCNTs',
    method: 'post',
    data: params,
    rawData: true,
  });
}

// 获取CompareStoreRank多国家切换到单国家时的数据源
export function getCompareStroeRankDefSource(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/compareMobileStoreRankingName',
    method: 'post',
    data: params,
    rawData: true,
  });
}

// 获取CompareGame-storerank可视化数据
export function fetchCompareMobileStoreRankCntTrends(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/compareMobileStoreRankCntTrends',
    method: 'post',
    data: params,
    rawData: true,
  });
}

// 获取CompareGame-storerank可视化数据
export function fetchCompareMobileStoreRankMulCntTrends(params: any): Promise<any> {
  return http({
    url: '/api/v1/intelligence_pc/compare/compareMobileStoreRankCNTsTrends',
    method: 'post',
    data: params,
    rawData: true,
  });
}
